import { Star1 } from "iconsax-react";
import { Modal, Spinner, Button } from "react-bootstrap";
import TabellaLista from "../../../../components/Tabella/TabellaLista";
import { ChipFilter, filtroMultiplo } from "../../../../components/Tabella/ChipFilter";
import { Fragment, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import MyApiClient from "../../../../../api-client/MyApiClient";
import DEFAULT_USER from "../../../../../images/DEFAULT_USER.png";
import { dateTimeSort } from "../../../../components/Util/oders";

// Valori dei filtri a chip, come compaiono nella lista.
const STATO_OPTIONS = ['Attivo', 'Completato', 'Inattivo'];
const ABBONAMENTO_OPTIONS = ['Smart', 'Premium'];

export const ListaPlayer = () => {
    const navigate = useNavigate();

    const [data_json, setDataJson] = useState(null);
    // Chip a scelta multipla: all'inizio tutti accesi
    const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);
    const [abbonamentoFilter, setAbbonamentoFilter] = useState(ABBONAMENTO_OPTIONS);

    const filteredData = useMemo(
        () =>
            data_json &&
            data_json.filter(
                (row) =>
                    filtroMultiplo(statoFilter, STATO_OPTIONS, row.status?.label) &&
                    filtroMultiplo(abbonamentoFilter, ABBONAMENTO_OPTIONS, row.abbonamento?.label),
            ),
        [data_json, statoFilter, abbonamentoFilter],
    );

    const [loadingShowed, setLoadingShowed] = useState(false);

    const data_column = [
        {
            Header: 'Data',
            Footer: 'Data',
            accessor: 'dateregistration',
            sortType: dateTimeSort,
            disableGlobalFilter: true,
        },
        {
            Header: 'Nome e Cognome',
            Footer: 'Nome e Cognome',
            accessor: 'name',
            Cell: ({ row }) => (
				<div style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                        src={row.original.imageUrl ? row.original.imageUrl : DEFAULT_USER}
                        alt={row.original.name}
                        style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        marginRight: '10px'
                        }}
                    />
                    {row.original.name}
				</div>
			)
        },
        {
            Header: 'Email',
            Footer: 'Email',
            accessor: 'email',
        },
        {
            Header: 'Abbonamento',
            Footer: 'Abbonamento',
            accessor: 'abbonamento',
            disableGlobalFilter: true,
            Cell: ({ value }) => {
                return (
                    <Button variant={`${value.class} light`} size="xs">
                        <span className="me-2"><Star1 size="24" variant={`${value.class==='dark' ? 'Bold': 'Bulk'}`} /></span>
                        {value.label}
                    </Button>
                );
            },
            disableFilters: true,
        },
        {
            Header: 'Stato',
            Footer: 'Stato',
            id: 'status',
            accessor: row => row.status?.label,
            disableGlobalFilter: true,
            Cell: ({ row }) => {
                const { class: cls, label } = row.original.status || {};
                return (
                    <div className="d-flex align-items-center">
                        <i className={`fa fa-circle me-1 ${cls}`} />
                        {label}
                    </div>
                );
            },
        },
    ];

    function openDetail(row) {
		navigate('/superadmin/anagrafiche/player/'+row.id);
	}

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    let token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();
            
                    setLoadingShowed(true);
                    const [membershipData] = await Promise.all([
                        apiClient.getProfilesByFilters(token,10000,null,'IDS_PLAY')
                    ]);
                    setLoadingShowed(false);
            
                    if(membershipData) {
                        let data_member = [];
                        membershipData.items.forEach(element => {
            
                            let image = null;
                            if(element.pictures && element.pictures[0] && element.pictures[0].uri) {
                                image = element.pictures[0].uri;
                            }
            
                            let status = null;
                            if(element.profileStatus==='INACTIVE') {
                                status = {
                                    "label": "Inattivo",
                                    "class": "text-danger"
                                };
                            } else if(element.profileStatus==='ACTIVE') {
                                status = {
                                    "label": "Attivo",
                                    "class": "text-success"
                                };
                            } else if(element.profileStatus==='COMPLETED') {
                                status = {
                                    "label": "Completato",
                                    "class": "text-success"
                                };
                            }

                            const createdAt = element.createdAt;
							const data = new Date(createdAt);
							const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
							const formattedDate = data.toLocaleDateString('it-IT', options);
            
                            let abbonamento = {
                                "label": "Smart",
                                "class": "dark"
                            };

                            if(element.accountPlan && element.accountPlan.length>0 && element.accountPlan[0] === 'PREMIUM') {
                                abbonamento = {
                                    "label": "Premium",
                                    "class": "warning"
                                };
                            }

                            let member_row = {
                                "id": element.userId,
                                "name": element.name,
                                "imageUrl": image,
                                "status": status || { "label": ({ SUSPENDED: "Sospeso", INVITED: "Invitato" })[element.profileStatus || element.status] || element.profileStatus || element.status || "—", "class": "" }, // stato non previsto: si mostra invece di bloccare la lista
                                "email": element.email,
                                "dateregistration": formattedDate,
                                abbonamento: abbonamento
                            };
                            data_member.push(member_row);
            
                        });
                        setDataJson(data_member);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
    
        fetchData();
    
    }, []);

    return (
        <>
            <Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

            <Fragment>
                <TabellaLista
                    openColumn={'name'}
                    openRow={(row) => openDetail(row)}
                    cardTitle={'Player'}
                    pageList={true}
                    hasSearch={true}
                    searchPlaceholder={'Cerca per nome o email'}
                    hasFilter={false}
                    filterControl={
                        <div className="sid-chip-filters">
                            <ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
                            <ChipFilter label="Abbonamento" options={ABBONAMENTO_OPTIONS} value={abbonamentoFilter} onChange={setAbbonamentoFilter} multiple />
                        </div>
                    }
                    hasAddMore={false}
                    data_column={data_column}
                    data_json={filteredData}
                    sort_by={'dateregistration'}
                    sort_type={'desc'}
                />
            </Fragment>
        </>
    )
}

export default ListaPlayer